import type { FormField } from '../../../../types/form';
import {
  BASE_FORM_FIELDS,
  type FormFieldRowType,
} from './bulk-uploader-validation';

function getSafeFormFieldId(label: string) {
  return label.replace(/\s/g, '_').replace(/[^\w\d_]/g, '');
}

export function buildBulkFormFields(rows: FormFieldRowType[]): FormField[] {
  return rows.map((field) => {
    const options = Object.entries(field)
      .filter(([key]) => key.startsWith('Option'))
      .map(([, value]) => ({
        description: '',
        value: String(value).trim(),
      }));
    const isBaseField = BASE_FORM_FIELDS.includes(field.Label);

    return {
      id: getSafeFormFieldId(field.Label),
      label: field.Label,
      ...(!isBaseField && { notes: field.Notes }),
      type: field.Type,
      required: field.Required === 'YES',
      options,
      base: field['Base'] === 'YES',
      disabled: field.Disabled === 'YES',
      hidden: field.Hidden === 'YES',
      default: field['Default Value'],
      min: field['Minimum Value'],
      max: field['Maximum Value'],
      nicheFieldsExcludeMode: isBaseField
        ? true
        : field['Niche Fields Mode'] === 'EXCLUDE',
      nicheFields:
        !isBaseField && field['Niche Fields']
          ? field['Niche Fields']
              .split(',')
              .map((nicheField) => nicheField.trim())
              .filter((nicheField) => nicheField.length > 0)
          : [],
    };
  });
}
